import React, { FC } from 'react';
import injectSheet from 'react-jss';
import Tooltip from 'HOC/Tooltip';
import styleSheet from './styles';
import { SearchInput } from './SearchInput';

interface Props {
  searchable?: boolean;
  name: string;
  placeholder?: string;
  width?: number;
  fields?: string[];
  error?: string;
  disabled?: boolean;
  disableToolTip?: boolean;
  classes?: any;
  onChange?: (e: object) => void;
  onSearch?: (e: object) => void;
  toolTipWidth?: string;
  disableInputOnly?: boolean;
}

const SearchBar: FC<Props> = (props: Props) => {
  const {
    searchable,
    name,
    fields,
    error,
    disabled,
    disableToolTip,
    classes,
    onChange,
    onSearch,
    toolTipWidth,
    placeholder,
    width,
    disableInputOnly = false,
  } = props;

  const tooltipText = fields.join(', ').trim();

  return (
    <div className={`${classes.searchBarContainer}`} data-testid="searchBar">
      {(!disableToolTip && (
        <Tooltip
          width={toolTipWidth || '195px'}
          position="right"
          text={`Search by ${tooltipText}`}
          offsetLeft={310}
          overrideEvents={{
            showToolTip: ['onFocus'],
            hideToolTip: ['onKeyUp', 'onBlur'],
          }}
        >
          <SearchInput
            placeholder={placeholder}
            width={width}
            disableInputOnly={disableInputOnly}
            searchable={searchable}
            name={name}
            error={error}
            onChange={onChange}
            onSearch={onSearch}
            disabled={disabled}
            ariaLabel={`search ${tooltipText}`}
          />
        </Tooltip>
      )) || (
        <SearchInput
          placeholder={placeholder}
          width={width}
          disableInputOnly={disableInputOnly}
          searchable={searchable}
          name={name}
          error={error}
          onChange={onChange}
          onSearch={onSearch}
        />
      )}
    </div>
  );
};

SearchBar.defaultProps = {
  searchable: false,
  fields: [],
  error: undefined,
  disabled: false,
  disableToolTip: false,
  classes: {},
  onChange: () => {},
  onSearch: () => {},
  toolTipWidth: '',
  disableInputOnly: false,
  placeholder: 'Search',
  width: 135,
};

export default injectSheet(styleSheet)(SearchBar);
